"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _zustand = _interopRequireDefault(require("zustand"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var useMapStore = (0, _zustand["default"])(function (set, get) {
  return {
    hovered: null,
    setHovered: function setHovered(hovered) {
      return set({
        hovered: hovered
      });
    },
    selected: null,
    setSelected: function setSelected(selected) {
      return set({
        selected: selected
      });
    }
  };
});
var _default = useMapStore;
exports["default"] = _default;